import { Action } from '@ngrx/store';

export class NGRXError<T = Action> {
	constructor(readonly action: T, readonly instance: any) { }
}